import Box from '../box'
Box.udta = function () {
  delete this.subBox
}
